import { render, staticRenderFns } from "./SwitchControl.vue?vue&type=template&id=459843b6&scoped=true&"
import script from "./SwitchControl.vue?vue&type=script&lang=ts&"
export * from "./SwitchControl.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchControl.vue?vue&type=style&index=0&id=459843b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459843b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
